import { useLocalStorage } from "usehooks-ts";

import {
  isThreadReadingOrder,
  THREAD_READING_ORDER,
  THREAD_READING_ORDER_STORAGE_KEY,
  type ThreadReadingOrder,
} from "./thread-reading-order";

/**
 * Which end of a thread a broker reads from: oldest-first, as threads have always read, or
 * newest-first.
 *
 * Stored as a string and narrowed on read so a corrupt value falls back to the default, the same
 * shape as the inbox list/thread layout preference. `useLocalStorage` broadcasts on write and every
 * instance listens, so the user menu, the thread view and the landing scroll stay in step without a
 * provider between them.
 */
export const useThreadReadingOrder = () => {
  const [storedReadingOrder, setStoredReadingOrder] = useLocalStorage<string>(
    THREAD_READING_ORDER_STORAGE_KEY,
    THREAD_READING_ORDER.oldestFirst
  );

  return {
    readingOrder: isThreadReadingOrder(storedReadingOrder) ? storedReadingOrder : THREAD_READING_ORDER.oldestFirst,
    setReadingOrder: (order: ThreadReadingOrder) => setStoredReadingOrder(order),
  };
};
